// AP-165 · Seletor de idioma do header (admin ERP).
import React from "react";
import { useI18n, AVAILABLE_LOCALES } from "../i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";
import { toast } from "sonner";

export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  const current = AVAILABLE_LOCALES.find((o) => o.code === locale) || AVAILABLE_LOCALES[0];

  const choose = async (code) => {
    await setLocale(code);
    const picked = AVAILABLE_LOCALES.find((o) => o.code === code);
    toast.success(`${picked?.flag || ""} ${picked?.label}`);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5"
                data-testid="language-switcher-trigger"
                title={t("language")}>
          <span className="text-base leading-none">{current.flag}</span>
          <span className="hidden md:inline text-xs font-medium">{current.code.toUpperCase()}</span>
          <Globe className="h-3.5 w-3.5 text-muted-foreground md:hidden" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {AVAILABLE_LOCALES.map((o) => (
          <DropdownMenuItem key={o.code}
                            data-testid={`language-opt-${o.code}`}
                            onSelect={() => choose(o.code)}
                            className={locale === o.code ? "font-semibold bg-primary/5" : ""}>
            <span className="mr-2 text-base">{o.flag}</span>
            <span className="flex-1">{o.label}</span>
            {locale === o.code && <span className="text-primary">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
